export const CONFIGS = {
  EXTEND_SESSION_TIMER: 900000, // 15 mins
  EXPIRED_SESSION_TIMER: 1200000, // 20 mins,
  TAGS: {
    COLLECT_AT_STORE: 'singtel:eshop-delivery/collect-at-store'
  },
  REQUEST_CODES: {
    GATE_REDIRECT: 'GATESVC_302'
  },
  YUU_MEMBERSHIP_CODE: 'yuu',
  CUSTOM_404_IMAGES: {
    MOBILE:
      'https://www.singtel.com/content/dam/singtel/eshop/Mobile/detox/holding-page/Detox/iPhone15-waiting-room-detox-banner-1280X750.jpg',
    DESKTOP:
      'https://www.singtel.com/content/dam/singtel/eshop/Mobile/detox/holding-page/Detox/iPhone15-waiting-room-detox-banner-2500X720.jpg'
  }
};

export const CP_ERROR_CODES = {
  CREDIT_LIMIT_UNSUCCESS: '50021',
  CREDIT_LIMIT_REVIEW: '50023'
};

export const CREDIT_LIMIT_FLOWTYPE = 'detoxMobile';
